// Custom Messages
export const ptCustomMessages = {
  teamEfficiency: "Eficiência da Equipa",
  teamMembers: "Membros da Equipa",
  dashboard: "Dashboard",
  planning: "Planning",
  profile: "Perfil",
  info: "Informação",
  language: "Language",
  trend: "Trend",
  volume: "Volume",
  centros: "Centros",
  myTeam: "My Team",
  cacifosInibidos: "Cacifos inibidos",
  allTeams: "Todas as Equipas",
  teamCalendar: "Calendário da equipa",
  saveChanges: "Gravar alterações",
  cancel: "Cancelar",
  siteTitle: "Smart Locker",
  startFreeTrial: "Start Free Trial",
  buyNow: "Buy Now",
  getSource: "Get the source code on GitHub",
  demoInfo:
    "This demo application is built using the following Kendo UI for Angular components.",
  firstName: "Primeiro nome",
  middleName: "Nome do meio",
  lastName: "Sobrenome",
  email: "Email",
  phoneNumber: "Número de telefone",
  country: "País",
  biography: "Short Biography",
  public: "Incluir no diretório público",
  team: "Equipa",
  employee: "Funcionário",
  contactName: "Nome",
  jobTitle: "Tipo de utilizador",
  status: "Estado",
  performance: "Performance",
  rating: "Avaliação",
  engagement: "Engagement",
  budget: "Budget",
  contacts: "Contactos",
  address: "Morada",
  phone: "Telefone",
  gridSearch: "Procurar em todas as colunas...",
  exportExcel: "Exportar para Excel",
  exportPdf: "Exportar para PDF",
  tools: "Ferramentas",
  tool: "Ferramenta",
  sites: "Locais",
  lockers: "Armários",
  name: "Nome",
  brand: "Marca",
  model: "Modelo",
  description: "Descrição",
  imagem: "Imagem",
  serial: "Serial",
  location: "Localização",
  remoteDevice: "Dispositivo remoto",
  escolherCentroDeCusto: "Escolher centro de custo",
  escolherArmario: "Escolher armário",
  cacifosComAnomalia: "Cacifos com anomalia",

  doors: "Portas",
  local: "Local",
  locais: "Locais",
  ligua: "Língua de trabalho",

  nomeCompartimento: "Porta",
  numArmario: "Nº armário",

  addModulos: "Adicionar módulo",
  naoPossivelMaisQueUmModuloPrincipal:
    "Não é possível adicionar mais do que um módulo principal",
  optionEletronica: "Eletrónica",

  users: "Utilizadores",
  user: "Utilizador",
  employeeCode: "Código de funcionário",
  validade: "Válido até",
  cardID: "ID cartão",
  teams: "Equipas",
  team: "Equipa",
  numeroDeFuncionarios: "Número de funcionários",
  pt: "Português",
  en: "Inglês",
  fr: "Francês",
  theField: "o campo",
  isRequired: "é obrigatório",
  error: "Erro",
  registoGravadoComSucesso: "Registo gravado com sucesso.",
  registoApagadoComSucesso: "Registo apagado com sucesso.",
  selecionartag: "Escolher opção",
  naoAtribuidoTag: "Não atribuído",
  nomeEquipa: "Nome equipa",
  parametrosDoSistema: "Parâmetros do sistema",
  parametros: "Parâmetros",
  arquivoGrandeDemais: "O arquivo excede o limite de tamanho de 1 MB.",
  legenda: "Legenda",
  qtd: "Qtd.",
  smtpServer: "Servidor  SMTP",
  smtpPort: "Porta SMTP",
  smtpPass: "Password SMTP",
  smtpFrom: "Remetente SMTP",
  UrlRecuperacaoPwd: "URI recuparação de password",
  EmailUsername: "Utilizador email",
  tooltypes: "Tipos de ferramentas",
  toolsubtypes: "Subtipos de ferramentas",
  toolsubtype: "Subtipo de ferramenta",
  size: "Tamanho",
  descontinuado: "Descontinuado",
  identificacao: "ID da ferramenta",
  numeroDeSerie: "Número de série",
  obs: "Observações",
  condicao: "Condição",
  state: "Estado",
  avaria: "Avaria",
  visaoGeral: "Visão geral",
  listaDeAvarias: "Lista de avarias típicas",
  novoTipoAvaria: "Novo tipo de avaria",
  configuracoes: "Configurações",
  gestaoArmarios: "Gestão de armários",
  gestaoUtilizadores: "Gestão de utilizadores",
  gestaoFerramentas: "Gestão de ferramentas",
  gestaoArtigos: "Gestão de artigos",
  artigos: "Artigos",
  centrosDeCusto: "Centros de custo",
  alocasaoDeRecursos: "Alocação de recursos",
  listaDeFerramentas: "Lista de ferramentas",
  confirmacao: "Confirmação",
  desejaRemover: "Deseja remover o registo selecionado",
  yes: "Sim",
  no: "Não",
  tooltype: "Tipo de ferramenta",
  toolsubtypes: "Subtipos de ferramentas",
  localPretty: "Localização do armário de ferramentas",
  avaria: "Avaria",
  bloqueada: "Bloqueada",
  abatida: "Abatida",
  diretor: "Diretor",
  diretores: "Diretores",
  supervisores: "Supervisores",
  codigo: "Código",
  import: "Importar",
  avariada: "Avariada",
  corPrincipal: "Cor principal",
  corSecundaria: "Cor secundária",
  endereco: "Endereço",
  descricaoFerramenta: "Descrição da ferramenta",
  tamanhoCacifo: "Tamanho do cacifo",
  numeroDeUtilizacoes: "Número de utilizações",
  addressCanal: "Endereço/Canal",
  inibido: "Inibido",
  nenhuma: "Nenhuma",
  configurarArmario: "Configurar armário",
  configuracaoDoArmario: "Configuração do armário",
  configuracao: "Configuração",
  quantidadeDesejada: "Quantidade desejada",
  quantidadeAlertaDeStock: "Quantidade alerta de stock",
  stockBaixo: "Stock baixo",
  localDoArmario: "Local do armário",
  anomalias: "Anomalias",

  toolTypeDados: "Detalhes",
  perfilAdministrador: "Administrador",
  ferramentasDiponiveisEquipa:
    "Tipos de ferramentas disponíveis para a equipa ",
    artigosDiponiveisEquipa: "Artigos disponíveis para a equipa ",
    cacifosComStockBaixo: "Cacifos com stock baixo",
  erroExtensaoFicheiroInvalida: "Erro: extensão do ficheiro não permitida.",
  importarUtilizadores: "Importar utilizadores",
  importarFerramentas: "Importar ferramentas",
  totalFerramentas: "Total ferramentas",
  ferramentasIndisponiveis: "Ferramentas indisponíveis",
  ferramentasAutorizadas: "Ferramentas autorizadas",
  descarregarModelo: "Descarregar modelo",

  terminarSessao: "Terminar sessão",

  infoFerramentasAutorizadas:
    "Indique o número máximo de Ferramentas, de cada Tipo, que um membro desta Equipa poderá ter na sua posse em simultâneo.",
  ativa: "Ativa",
  bloqueada: "Bloqueada",
  pendente: "Pendente",
  depositada: "Depositada",
  levantada: "Levantada",

  // Página de login
  erroLoginNecessario: "Erro: login é obrigatório.",
  erroPasswordNecessaria: "Erro: password é obrigatória.",
  esqueceuPassword: "Esqueceu-se da palavra-passe?",
  loginSenhaInvalidos: "Login ou password inválido.",

  //Recuperar senha
  recuperarPassword: "Recuperar password",
  btnEnviar: "Enviar",

  // Alterar senha
  alterarPassword: "Alterar password",
  atualPassword: "Password atual",
  novaPassword: "Nova password",
  novaPasswordNovamente: "Reescreve a nova password",
  passwordAlteradaComSucesso: "Password alterada com sucesso",
  passwordsNaoSaoIguais: "As passwords não são iguais",

  //Movimentos
  eventos: "Eventos",
  movimentos: "Movimentos",
  movDataHora: "Data Hora",
  de: "De:",
  ate: "Até:",
  filtrarEntreDatas: "Filtrar entre datas",
  preencherIntervaloDatas: "Tem de preencher o intervalo de datas.",

  // Dashboard
  escolherLocal: "Escolher local",
  outrosIndicadores: "Outros indicadores",
  ferramentasNaoDepositadas: "Ferramentas não entregues",
  portasIbibidas: "Portas inibidas",
  utilizadoresAusentes: "Utilizadores ausentes",
  ferramentasBloqueadas: "Ferramentas bloqueadas",
  estadoFerramentas: "Estado das ferramentas",
  avariasReportadas: "Avarias reportadas",
  ocupacaoArmarios: "Ocupação dos armários",
  tipos: "Tipos",
  relatorios: "Relatórios",
  inventario: "Inventário",
  consumo: "Consumo",
  associacaoArtigos: "Associação de artigos",
  associacaoArtigosTeam: "Associação à equipa",
  associacaoArtigosArmario: "Associação ao armário",

  // Label botões
  btnEliminar: "Eliminar",
  btnCriar: "Criar",
  btnAdicionar: "Adicionar",
  btnEditar: "Editar",
  btnVisualizar: "Visualizar",
  btnVisualizarEstadoArmario: "Visualizar estado do Armário",
  btnExportarExcel: "Exportar Excel",
  btnExportarPDF: "Exportar PDF",
  btnFerramentasAutorizadas: "Ferramentas autorizadas",
  btnArtigosAutorizados: "Artigos autorizados",
  btnImportar: "Importar",
  quantidadeRemover: "Quantidade a remover",
  quantidadeRepor: "Quantidade a repor",
  // Artigos
  artigo: "Artigo",
  codigoInterno: "Código interno",
  codigoFabricante: "Código do fabricante",
  quantidade: "Quantidade",
  quantidadeRemanescente: "Quantidade remanescente",
  stock: "Stock",
  mostrarArtigosDescontinuados: "Mostrar artigos descontinuados",
  importarArtigos: "Importar artigos",

  // Centros de custo
  centroDeCusto: "Centro de custo",
  mostrarCentrosDeCustoDescontinuados:
    "Mostrar centros de custo descontinuados",
  importarCentrosDeCusto: "Importar centros de custo",

  // Entidades
  entidades: "Entidades",
  entidade: "Entidade",
  solucao: "Solução",

  // Movimentos IV
  tipo: "Tipo",
  anomalia: "Anomalia",

  // Alertas
  alerta: "Alerta",
  alertas: "Alertas",
  notas: "Notas",
  dataHoraAtualizacao: "Data Hora Atualização",

  // PDFs
  pagina: "Página",
  de_: "de",

  // Armários
  armario: "Armário",
  armarios: "Armários",
  modulo: "Módulo",
  modulos: "Módulos",
  cacifo: "Cacifo",
  cacifos: "Cacifos",
  estadoDoArmario: "Estado do Armário",
  configurcaoDoArmario: "Configuração do Armário",

  // Imagens
  selecionarImagem: "Selecionar imagem",
  largueAImagemAqui: "Solte a imagem aqui",
  extensaoFicheiroNaoSuportada: "Extensão de ficheiro não suportada",

  filtrar: "Filtrar",
  permissao: "Permissão",
};

// Kendo Angular Component Messages
export const ptComponentMessages = {
  // Grid
  "kendo.grid.groupPanelEmpty":
    "Arraste um cabeçalho de coluna e solte-o aqui para agrupar por essa coluna",
  "kendo.grid.noRecords": "Não há registos disponíveis.",
  "kendo.grid.pagerFirstPage": "Ir para a primeira página",
  "kendo.grid.pagerPreviousPage": "Ir para a página anterior",
  "kendo.grid.pagerNextPage": "Ir para a página seguinte",
  "kendo.grid.pagerLastPage": "Ir para a página anterior",
  "kendo.grid.pagerPage": "Página",
  "kendo.grid.pagerOf": "de",
  "kendo.grid.pagerItems": "itens",
  "kendo.grid.pagerItemsPerPage": "itens por página",
  "kendo.grid.pagerPageNumberInputTitle": "Número de página",
  "kendo.grid.filter": "Filtro",
  "kendo.grid.filterEqOperator": "É igual a",
  "kendo.grid.filterNotEqOperator": "Não é igual a",
  "kendo.grid.filterIsNullOperator": "É nulo",
  "kendo.grid.filterIsNotNullOperator": "Não é nulo",
  "kendo.grid.filterIsEmptyOperator": "É vazio",
  "kendo.grid.filterIsNotEmptyOperator": "Não é vazio",
  "kendo.grid.filterStartsWithOperator": "Começa por",
  "kendo.grid.filterContainsOperator": "Contém",
  "kendo.grid.filterNotContainsOperator": "Não contém",
  "kendo.grid.filterEndsWithOperator": "Termina com",
  "kendo.grid.filterGteOperator": "É maior que ou igual a",
  "kendo.grid.filterGtOperator": "É maior que",
  "kendo.grid.filterLteOperator": "É menor ou igual a",
  "kendo.grid.filterLtOperator": "É menor que",
  "kendo.grid.filterIsTrue": "É verdadeiro",
  "kendo.grid.filterIsFalse": "É falso",
  "kendo.grid.filterBooleanAll": "(Todos)",
  "kendo.grid.filterAfterOrEqualOperator": "É posterior ou igual a",
  "kendo.grid.filterAfterOperator": "É posterior",
  "kendo.grid.filterBeforeOperator": "É antes",
  "kendo.grid.filterBeforeOrEqualOperator": "É anterior ou igual a",
  "kendo.grid.filterFilterButton": "Filtro",
  "kendo.grid.filterClearButton": "Limpar",
  "kendo.grid.filterAndLogic": "E",
  "kendo.grid.filterOrLogic": "OU",
  "kendo.grid.filterDateToggle": "Alternar calendário",
  "kendo.grid.filterDateToday": "Hoje",
  "kendo.grid.filterNumericDecrement": "Diminuir valor",
  "kendo.grid.filterNumericIncrement": "Aumentar valor",
  "kendo.grid.loading": "Carregar",
  "kendo.grid.sort": "Ordenar",
  "kendo.grid.columnMenu": "Menu Coluna",
  "kendo.grid.columns": "Colunas",
  "kendo.grid.lock": "Bloquear",
  "kendo.grid.unlock": "Desbloquear",
  "kendo.grid.stick": "Pregar",
  "kendo.grid.unstick": "Despregar",
  "kendo.grid.setColumnPosition": "Definir posição da coluna",
  "kendo.grid.sortAscending": "Ordernar ascendente",
  "kendo.grid.sortDescending": "Ordernar decendente",
  "kendo.grid.columnsApply": "Aplicar",
  "kendo.grid.columnsReset": "Reset",
  "kendo.grid.sortable": "Ordenável",
  "kendo.grid.sortedAscending": "Ordernado ascendente",
  "kendo.grid.sortedDescending": "Ordernado decendente",
  "kendo.grid.sortedDefault": "Not sorted",

  // DropDowns
  "kendo.autocomplete.noDataText": "Sem dados",
  "kendo.autocomplete.clearTitle": "Limpar",
  "kendo.combobox.noDataText": "Sem dados",
  "kendo.combobox.clearTitle": "Limpar",
  "kendo.dropdownlist.noDataText": "Sem dados",
  "kendo.dropdownlist.clearTitle": "Limpar",

  // Calendar
  "kendo.calendar.today": "HOJE",

  // TextBox
  "kendo.textbox.clearTitle": "Limpar",

  // DatePicker
  "kendo.datepicker.today": "HOJE",
  "kendo.datepicker.toggle": "Alternar calendário",

  // DateInput
  "kendo.dateinput.increment": "Aumentar valor",
  "kendo.dateinput.decrement": "Decrease value",

  // NumericTextBox
  "kendo.numerictextbox.increment": "Aumentar valor",
  "kendo.numerictextbox.decrement": "Decrease value",

  // DateTimePicker
  "kendo.datetimepicker.dateTab": "Data",
  "kendo.datetimepicker.dateTabLabel": "Date tab",
  "kendo.datetimepicker.timeTab": "Time",
  "kendo.datetimepicker.timeTabLabel": "Time tab",
  "kendo.datetimepicker.toggle": "Toggle popup",
  "kendo.datetimepicker.accept": "Set",
  "kendo.datetimepicker.acceptLabel": "Set",
  "kendo.datetimepicker.cancel": "Cancel",
  "kendo.datetimepicker.cancelLabel": "Cancel",
  "kendo.datetimepicker.now": "Agora",
  "kendo.datetimepicker.nowLabel": "Selecinar agora",
  "kendo.datetimepicker.today": "HOJE",
  "kendo.datetimepicker.prevButtonTitle": "Navegue para a vista anterior",
  "kendo.datetimepicker.nextButtonTitle": "Navegue para a vista seguinte",

  // TimePicker
  "kendo.timepicker.accept": "Set",
  "kendo.timepicker.acceptLabel": "Set",
  "kendo.timepicker.cancel": "Cancelar",
  "kendo.timepicker.cancelLabel": "Cancelar",
  "kendo.timepicker.now": "Agora",
  "kendo.timepicker.nowLabel": "Agora",
  "kendo.timepicker.toggle": "Toggle time list",

  // FileSelect
  "kendo.fileselect.cancel": "Cancelar",
  "kendo.fileselect.clearSelectedFiles": "Limpar",
  "kendo.fileselect.dropFilesHere": "Drop files here to upload",
  "kendo.fileselect.externalDropFilesHere":
    "Drag and drop files here to upload",
  "kendo.fileselect.filesBatchStatus": "ficheiros",
  "kendo.fileselect.filesBatchStatusFailed": "files failed to upload.",
  "kendo.fileselect.filesBatchStatusUploaded": "files successfully uploaded.",
  "kendo.fileselect.fileStatusFailed": "File failed to upload.",
  "kendo.fileselect.fileStatusUploaded": "File successfully uploaded.",
  "kendo.fileselect.headerStatusPaused": "Paused",
  "kendo.fileselect.headerStatusUploaded": "Done",
  "kendo.fileselect.headerStatusUploading": "Uploading...",
  "kendo.fileselect.invalidFileExtension": "File type not allowed.",
  "kendo.fileselect.invalidMaxFileSize": "File size too large.",
  "kendo.fileselect.invalidMinFileSize": "File size too small.",
  "kendo.fileselect.remove": "Remove",
  "kendo.fileselect.retry": "Retry",
  "kendo.fileselect.select": "Select files...",
  "kendo.fileselect.uploadSelectedFiles": "Upload files",

  // Scheduler
  "kendo.scheduler.agendaViewTitle": "Agenda",
  "kendo.scheduler.allDay": "all day",
  "kendo.scheduler.allEvents": "All events",
  "kendo.scheduler.calendarToday": "TODAY",
  "kendo.scheduler.cancel": "Cancel",
  "kendo.scheduler.save": "Save",
  "kendo.scheduler.editorEventTitle": "Title",
  "kendo.scheduler.editorEventStart": "Start",
  "kendo.scheduler.editorEventStartTimeZone": "Start Time Zone",
  "kendo.scheduler.editorEventEnd": "End",
  "kendo.scheduler.editorEventEndTimeZone": "End Time Zone",
  "kendo.scheduler.dateHeader": "Date",
  "kendo.scheduler.dayViewTitle": "Day",
  "kendo.scheduler.deleteConfirmation":
    "Are you sure you want to delete this event?",
  "kendo.scheduler.deleteDialogTitle": "Delete Event",
  "kendo.scheduler.deleteOccurrence": "Delete current occurrence",
  "kendo.scheduler.deleteRecurringConfirmation":
    "Do you want to delete only this event occurrence or the whole series?",
  "kendo.scheduler.deleteRecurringDialogTitle": "Delete Recurring Item",
  "kendo.scheduler.deleteSeries": "Delete the series",
  "kendo.scheduler.deleteTitle": "Delete",
  "kendo.scheduler.destroy": "Delete",
  "kendo.scheduler.editOccurrence": "Edit current occurrence",
  "kendo.scheduler.editorEventAllDay": "All Day Event",
  "kendo.scheduler.editorEventDescription": "Description",
  "kendo.scheduler.editorEventSeparateTimeZones": "End in different Time Zone",
  "kendo.scheduler.editorEventTimeZone": "Specify Time Zone",
  "kendo.scheduler.editorTitle": "Event",
  "kendo.scheduler.editRecurringConfirmation":
    "Do you want to edit only this event occurrence or the whole series?",
  "kendo.scheduler.editRecurringDialogTitle": "Edit Recurring Item",
  "kendo.scheduler.editSeries": "Edit the series",
  "kendo.scheduler.eventHeader": "Event",
  "kendo.scheduler.monthViewTitle": "Month",
  "kendo.scheduler.multiDayViewTitle": "Multi-Day",
  "kendo.scheduler.nextTitle": "Next",
  "kendo.scheduler.previousTitle": "Previous",
  "kendo.scheduler.recurrenceEditorDailyInterval": "day(s)",
  "kendo.scheduler.recurrenceEditorDailyRepeatEvery": "Repeat every",
  "kendo.scheduler.recurrenceEditorEndAfter": "After",
  "kendo.scheduler.recurrenceEditorEndLabel": "End",
  "kendo.scheduler.recurrenceEditorEndNever": "Never",
  "kendo.scheduler.recurrenceEditorEndOccurrence": "occurrence(s)",
  "kendo.scheduler.recurrenceEditorEndOn": "On",
  "kendo.scheduler.recurrenceEditorFrequenciesDaily": "Daily",
  "kendo.scheduler.recurrenceEditorFrequenciesMonthly": "Monthly",
  "kendo.scheduler.recurrenceEditorFrequenciesNever": "Never",
  "kendo.scheduler.recurrenceEditorFrequenciesWeekly": "Weekly",
  "kendo.scheduler.recurrenceEditorFrequenciesYearly": "Yearly",
  "kendo.scheduler.recurrenceEditorMonthlyDay": "Day",
  "kendo.scheduler.recurrenceEditorMonthlyInterval": "month(s)",
  "kendo.scheduler.recurrenceEditorMonthlyRepeatEvery": "Repeat every",
  "kendo.scheduler.recurrenceEditorMonthlyRepeatOn": "Repeat on",
  "kendo.scheduler.recurrenceEditorOffsetPositionsFirst": "First",
  "kendo.scheduler.recurrenceEditorOffsetPositionsFourth": "Fourth",
  "kendo.scheduler.recurrenceEditorOffsetPositionsLast": "Last",
  "kendo.scheduler.recurrenceEditorOffsetPositionsSecond": "Second",
  "kendo.scheduler.recurrenceEditorOffsetPositionsThird": "Third",
  "kendo.scheduler.recurrenceEditorRepeat": "Repeat",
  "kendo.scheduler.recurrenceEditorWeekdaysDay": "Day",
  "kendo.scheduler.recurrenceEditorWeekdaysWeekday": "Weekday",
  "kendo.scheduler.recurrenceEditorWeekdaysWeekendday": "Weekend Day",
  "kendo.scheduler.recurrenceEditorWeeklyInterval": "week(s)",
  "kendo.scheduler.recurrenceEditorWeeklyRepeatEvery": "Repeat every",
  "kendo.scheduler.recurrenceEditorWeeklyRepeatOn": "Repeat on",
  "kendo.scheduler.recurrenceEditorYearlyInterval": "year(s)",
  "kendo.scheduler.recurrenceEditorYearlyOf": "of",
  "kendo.scheduler.recurrenceEditorYearlyRepeatEvery": "Repeat every",
  "kendo.scheduler.recurrenceEditorYearlyRepeatOn": "Repeat on",
  "kendo.scheduler.showFullDay": "Show full day",
  "kendo.scheduler.showWorkDay": "Show business hours",
  "kendo.scheduler.timeHeader": "Time",
  "kendo.scheduler.timelineMonthViewTitle": "Timeline Month",
  "kendo.scheduler.timelineViewTitle": "Timeline",
  "kendo.scheduler.timelineWeekViewTitle": "Timeline Week",
  "kendo.scheduler.today": "Today",
  "kendo.scheduler.weekViewTitle": "Week",
  "kendo.scheduler.workWeekViewTitle": "Work Week",

  // RecurrenceEditor
  "kendo.recurrenceeditor.dailyInterval": "day(s)",
  "kendo.recurrenceeditor.dailyRepeatEvery": "Repeat every",
  "kendo.recurrenceeditor.endAfter": "After",
  "kendo.recurrenceeditor.endLabel": "End",
  "kendo.recurrenceeditor.endNever": "Never",
  "kendo.recurrenceeditor.endOccurrence": "occurrence(s)",
  "kendo.recurrenceeditor.endOn": "On",
  "kendo.recurrenceeditor.frequenciesDaily": "Daily",
  "kendo.recurrenceeditor.frequenciesMonthly": "Monthly",
  "kendo.recurrenceeditor.frequenciesNever": "Never",
  "kendo.recurrenceeditor.frequenciesWeekly": "Weekly",
  "kendo.recurrenceeditor.frequenciesYearly": "Yearly",
  "kendo.recurrenceeditor.monthlyDay": "Day",
  "kendo.recurrenceeditor.monthlyInterval": "month(s)",
  "kendo.recurrenceeditor.monthlyRepeatEvery": "Repeat every",
  "kendo.recurrenceeditor.monthlyRepeatOn": "Repeat on",
  "kendo.recurrenceeditor.offsetPositionsFourth": "Fourth",
  "kendo.recurrenceeditor.offsetPositionsLast": "Last",
  "kendo.recurrenceeditor.offsetPositionsSecond": "Second",
  "kendo.recurrenceeditor.offsetPositionsThird": "Third",
  "kendo.recurrenceeditor.repeat": "Repeat",
  "kendo.recurrenceeditor.weekdaysDay": "Day",
  "kendo.recurrenceeditor.weekdaysWeekday": "Weekday",
  "kendo.recurrenceeditor.weekdaysWeekendday": "Weekend Day",
  "kendo.recurrenceeditor.weeklyInterval": "week(s)",
  "kendo.recurrenceeditor.weeklyRepeatEvery": "Repeat every",
  "kendo.recurrenceeditor.weeklyRepeatOn": "Repeat on",
  "kendo.recurrenceeditor.yearlyInterval": "year(s)",
  "kendo.recurrenceeditor.yearlyOf": "of",
  "kendo.recurrenceeditor.yearlyRepeatEvery": "Repeat every",
  "kendo.recurrenceeditor.yearlyRepeatOn": "Repeat on",
};
